var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lymphomap_main"},[_c('div',{staticClass:"lymphomap_wrp"},[(!_vm.userAgreementState)?_c('user-agreement-popup'):_vm._e(),_c('div',{staticClass:"lymphomap_inner_form_wrp"},[_c('div',{staticClass:"container"},[_c('algo-first'),_c('algo-two'),_c('algo-third'),_c('algo-four')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }